module.exports = __webpack_public_path__ + "media/images/print-footer-adc9ceceac04fc06afbe4a25149173ba.jpg";